import { isExist, isString } from '@util/data/is-exist';

export const stringReplacer = (
  value: string,
  variables: Record<string, string>,
  currentEnv: string,
  shouldClear = false,
) => {
  let link = value;
  const keyVars = /{{(.*?)}}/.exec(value);

  if (Array.isArray(keyVars)) {
    keyVars.forEach((key) => {
      const currentKey = key.replace('$env', currentEnv);
      if (isString(variables[currentKey])) {
        link = link.replace(`{{${key}}}`, variables[currentKey]);
      }
    });
  }

  link = link.replace(/{{\$env}}/g, currentEnv);

  if (shouldClear) link = link.replace(/{{(.*?)}}/, '');

  return link;
};

export const paramsReplacer = (
  value: string,
  variables: Record<string, string>,
  currentEnv: string,
  shouldClear = false,
) => {
  let link = value;
  const keyVars = /:(\w+)/.exec(value);

  if (Array.isArray(keyVars)) {
    keyVars.forEach((key) => {
      const currentKey = key.replace('$env', currentEnv);
      if (isExist(variables[currentKey])) {
        link = link.replace(`:${key}`, variables[currentKey]);
      }
    });
  }

  link = link.replace(/:\$env/g, currentEnv);

  if (shouldClear) link = link.replace(/:(.*?)/, '');

  return isString(link) ? link : value;
};

export const getActiveItems = (items: any[]) => items.filter((item) => item.disabled !== true);
